module.exports = "/_next/static/images/1-1183101fd5ee0c9a7b902db09f313bb4.jpg";